<template>
  <div id="dicas">
    <div
      class="toast"
      role="alert"
      id="main-toast"
      aria-live="assertive"
      :class="{ 'main-doc': !this.selfie }"
      aria-atomic="true"
    >
      <div class="toast-body">
        <p>{{ this.tituloMain }}</p>
        <button type="button" v-on:click="verDicias()" class="btn btn-link">
          Ver dicas
        </button>
      </div>
    </div>

    <div
      class="toast"
      role="alert"
      id="selfie-toast"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-header">
        <div id="close-toast" v-on:click="close()"></div>
        <i class="bi bi-dash-lg"></i>
      </div>
      <div class="toast-body">
        <DicasSelfie v-if="selfie"></DicasSelfie>
        <DicasDoc :txt-titulo="tituloDoc" v-if="!selfie"></DicasDoc>
      </div>
    </div>
  </div>
</template>

<script>
import DicasSelfie from "./DicasSelfie";
import DicasDoc from "./DicasDoc";
import AppService from "../../services/AppService";

export default {
  name: "Dicas",
  components: { DicasDoc, DicasSelfie },
  props: {
    selfie: { type: Boolean },
    frente: { type: Boolean },
    tipo: { type: String },
  },
  computed: {
    tituloDoc: function () {
      let appService = new AppService();
      let tipo =
        appService.tipoDOC().outro === this.tipo ? "documento" : this.tipo;
      let msg = "Algumas dicas pra fotografar ";
      msg += appService.tipoDOC().cnh === this.tipo ? "sua " : "seu ";
      msg += tipo;
      return msg;
    },
    tituloMain: function () {
      if (this.selfie) {
        return "Posicione seu rosto na moldura e siga as instruções da tela. A foto será tirada automaticamente.";
      }
      let appService = new AppService();
      let tipo =
        appService.tipoDOC().outro === this.tipo ? "documento" : this.tipo;
      let msg = "Posicione ";
      msg += this.frente ? "a frente " : "o verso ";
      msg += appService.tipoDOC().cnh === this.tipo ? "da " : "do ";
      msg += tipo + " e siga as instruções da tela.";
      msg += appService.tipoDOC().outro !== this.tipo ? " A foto será capturada automaticamente." : "";
      return msg;
    },
  },
  methods: {
    verDicias: function () {
      let data = {
        CNH: "DicasDocsCnh",
        RG: "DicasDocsRg",
        OUTRO: "DicasDocsOutros",
      };
      let appService = new AppService();
      $("#selfie-toast").slideDown("slow");
    },
    close: function () {
      $("#selfie-toast").slideUp("slow");
    },
  },
};
</script>

<style scoped>
#main-toast {
  opacity: inherit;
  z-index: 9999999;
  position: absolute;
  background-color: #fff;
  margin: 0;
  margin-top: 1vh;
  flex-basis: initial;
  max-width: initial;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
}

.main-doc {
  margin-left: 0;
}
#main-toast p {
  margin: 0;
  color: #000;
}
#main-toast .toast-body {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.7rem;
  justify-content: space-between;
}
#main-toast button {
  font-size: 0.9rem;
  padding: 0;
}

#selfie-toast {
  opacity: 1;
  z-index: 9999999;
  bottom: -1px;
  position: absolute;
  flex-basis: inherit;
  background-color: #fff;
  -webkit-border-top-left-radius: 1.25rem;
  -webkit-border-top-right-radius: 1.25rem;
  -moz-border-radius-topleft: 1.25rem;
  -moz-border-radius-topright: 1.25rem;
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  display: none;
  max-width: inherit;
  width: 95vw;
  left: 50%;
  transform: translateX(-50%);
}
#selfie-toast i {
  text-align: center;
  position: relative;
  margin: 0 auto;
  font-size: 1rem;
  font-weight: bold;
}

#selfie-toast .toast-header {
  border-top-left-radius: calc(1.25rem - 1px);
  border-top-right-radius: calc(1.25rem - 1px);
}

#close-toast{
  width: 100%;
  padding-bottom: 47vh;
  position: absolute;
  top: -42vh;
  left: 0;
  z-index: 1;
}

@media (max-device-height: 640px) {
  #main-toast .toast-body {
    padding: 0;
    padding-left: 0.5rem;
  }
}

@media (min-width: 768px) {
  #main-toast,
  #selfie-toast {
    width: 41vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Dicas.vue